/* Cookiebar
 */
(function ($) {
  $.cookieBar = function (options, val) {
    var self = this;
    var userLanguage = navigator.language || navigator.userLanguage;
    var defaults = {
      consentVersion: '1.0',
      title: 'How we use cookies',
      message: 'We use cookies to track usage and preferences.',
      //Message displayed on bar
      settingsButtonText: 'Settings',
      settingsTitle: 'Settings for cookies',
      settingsSmallText: 'You can select which cookies you would like to accept.',
      settingsAcceptButtonText: 'Accept & close',
      boxes: [{
        id: 'all',
        checked: true,
        callback: function callback() {}
      }],
      required: false,
      acceptText: 'I Understand',
      //Text on accept/enable button
      expireDays: 365,
      //Number of days for cookieBar cookie to be stored for
      prepend: true,
      element: 'body' //Element to append/prepend cookieBar to. Remember "." for class or "#" for id.

    };

    if (userLanguage === 'sv-SE') {
      defaults.boxes[0].title = '<b>Säkerställa nödvändig teknisk funktionalitet och säkerhet.</b> Dessa kakor är nödvändiga för att webbplatsen ska fungera som den ska och för att skydda webbplatsen och går därför inte att stänga av.';
      defaults.boxes[0].text = 'Dessa kakor är nödvändiga för att webbplatsen ska fungera som den ska och för att skydda webbplatsen och går därför inte att stänga av.';
    } else {
      defaults.boxes[0].title = '<b>Ensure necessary technical functionality and security.</b>';
      defaults.boxes[0].text = 'These cookies are necessary for the website to function properly and to protect the website and can therefore not be shut down.';
    }

    self.options = $.extend(defaults, options);
    self.cookieValue = ''; //Appends the cookie settings link

    if (self.options.settingsContainer !== undefined && self.options.settingsLinkButton !== undefined) {
      var container = $(self.options.settingsContainer);
      var wrapper = $(self.options.settingsWrapper);
      var link = $(self.options.settingsLinkButton);
      wrapper.append(link);
      container.append(wrapper);
      link.click(function () {
        self.cookieSettingsElement.show();
      });
    } //Sets expiration date for cookie


    var expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + self.options.expireDays * 24 * 60 * 60 * 1000);
    expireDate = expireDate.toGMTString();

    self.onLoad = function () {
      // Retrieves current cookie preference
      var i;
      var aCookie,
          aCookies = document.cookie.split('; ');

      for (i = 0; i < aCookies.length; i++) {
        aCookie = aCookies[i].split('=');

        if (aCookie[0] == 'cb-enabled') {
          try {
            self.cookieValue = JSON.parse(aCookie[1]);
          } catch (e) {
            return;
          }

          if (self.cookieValue.consentVersion !== self.options.consentVersion) {
            document.cookie = "cb-enabled= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            self.cookieValue = '';
            break;
          }

          self.options.boxes.forEach(function (box, index) {
            if (self.cookieValue.selectedBoxIds.includes(box.id)) {
              box.checked = true;

              if (!box.callbackRun) {
                box.callback();
                box.callbackRun = true;
              }
            }
          });
          break;
        }
      }
    };

    self.acceptAll = function () {
      self.options.boxes.forEach(function (box, index) {
        box.checked = true;
      });
    };

    self.acceptEssential = function () {
      self.options.boxes.forEach(function (box, index) {
        if (box.required && !box.callbackRun) {
          box.callback();
          box.callbackRun = true;
        }
      });
    };

    self.updateCookieSettings = function () {
      var selectedBoxIds = [];
      var shouldReloadPage = true;
      self.options.boxes.forEach(function (box, index) {
        if (box.checked) {
          if (self.cookieValue === '' || self.cookieValue.selectedBoxIds === undefined || !self.cookieValue.selectedBoxIds.includes(box.id)) {
            if (!box.callbackRun) {
              box.callback();
              box.callbackRun = true;
            }
          }

          selectedBoxIds.push(box.id);
        }
      });
      self.cookieValue = JSON.stringify({
        consentVersion: self.options.consentVersion,
        selectedBoxIds: selectedBoxIds
      });
      document.cookie = 'cb-enabled=' + self.cookieValue + '; expires=' + expireDate + '; path=/';

      if (self.cookieBarElement) {
        self.cookieBarElement.remove();
      }

      self.cookieSettingsElement.hide();

      if (shouldReloadPage) {
        location.reload();
        return false;
      }
    };

    self.onLoad(); // Sets up the smaller cookie bar

    self.buttonWrapper = $('<div class="cb-button-wrapper"></div>');
    self.acceptButton = $('<button class="btn cb-accept">' + self.options.acceptText + '</button>');
    self.settingsButton = $('<button class="cb-settings btn">' + self.options.settingsButtonText + '</button>');
    self.closeButton = $('<span class="cb-close">x</span>'); // Displays the cookie bar if arguments met

    if (self.cookieValue == '') {
      self.cookieBarElement = $('<div id="cookie-bar" class="cookie-bar"></div>');
      self.cookieBarElement.append(self.closeButton);
      self.cookieBarElement.append('<h3 class="cb-title">' + self.options.title + '</h3><p class="cb-description">' + self.options.message + '</p>');
      self.buttonWrapper.append(self.acceptButton).append(self.settingsButton);
      self.cookieBarElement.append(self.buttonWrapper);

      if (self.options.element) {
        if (self.options.prepend) {
          $(self.options.element).prepend(self.cookieBarElement);
        } else {
          $(self.cookieBarElement).insertAfter(self.options.element);
        }
      }
    }

    self.acceptButton.click(function () {
      setTimeout(function () {
        self.acceptAll();
        self.updateCookieSettings();
      }, 200);
    });
    self.settingsButton.click(function () {
      setTimeout(function () {
        self.cookieBarElement.hide();
        self.cookieSettingsElement.show();
      }, 200);
    });
    self.closeButton.click(function () {
      self.acceptEssential();
      self.cookieBarElement.hide();
    }); // End smaller cookie bar
    // Sets up bigger settings box

    self.settingsAcceptButton = $('<button class="btn cb-accept">' + self.options.settingsAcceptButtonText + '</button>');
    self.settingsCloseButton = $('<span class="cb-close">x</span>');
    var boxes = [];
    self.options.boxes.forEach(function (box, index) {
      var boxLabel = $("<label class=\"cb-box-label\"><p><b>".concat(box.title, "</b> <span id=\"cb-box-text\">").concat(box.text, "</span></p></label>"));
      var boxCheckbox = $("<span\n                role=\"checkbox\"\n                class=\"cb-checkbox\"\n                tabindex=\"".concat(index + 1, "\"\n                ").concat(box.required ? 'disabled' : '', "\n                aria-checked=").concat(box.checked ? 'true' : 'false', "></span>"));
      var boxElement = $("<div class=\"cb-box-wrapper\"></div>");
      boxElement.prepend(boxLabel);
      boxElement.prepend(boxCheckbox);
      boxCheckbox.click(function () {
        self.changeCheckbox(boxCheckbox, box);
      });
      boxCheckbox.keydown(function (e) {
        if (e.keyCode === 32) {
          e.preventDefault();
          self.changeCheckbox(boxCheckbox, box);
        }
      });
      boxes.push(boxElement);
    });

    self.changeCheckbox = function (checkbox, box) {
      if (checkbox.is('[disabled]')) {
        return;
      }

      var oldCheckedValue = checkbox.attr("aria-checked") === "true";
      checkbox.attr("aria-checked", !oldCheckedValue);
      box.checked = !oldCheckedValue;
    };

    self.cookieSettingsElement = $('<div id="cookie-settings-bar" class="cookie-bar" style="display:none;"></div>');
    self.cookieSettingsElement.append(self.settingsCloseButton);
    self.cookieSettingsElement.append('<h3 class="cb-title">' + self.options.settingsTitle + '</h3><p class="cb-description">' + self.options.settingsSmallText + '</p>');
    self.cookieSettingsElement.append(boxes);
    self.cookieSettingsElement.append(self.settingsAcceptButton);
    self.settingsAcceptButton.click(function () {
      setTimeout(function () {
        self.updateCookieSettings();
      }, 200);
    });
    self.settingsCloseButton.click(function () {
      self.acceptEssential();
      self.cookieSettingsElement.hide();
    });

    if (self.options.element) {
      if (self.options.prepend) {
        $(self.options.element).prepend(self.cookieSettingsElement);
      } else {
        $(self.cookieSettingsElement).insertAfter(self.options.element);
      }
    } // End bigger settings box


    return {
      getBoxes: function getBoxes() {
        return self.options.boxes;
      },
      showSettings: function showSettings() {
        self.cookieSettingsElement.show();
      }
    };
  };
})(jQuery);